import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { UserOrganizationAffiliation } from "../affiliations.types";

export type UseFetchUserAffiliationsResult = {
  affiliations: UserOrganizationAffiliation[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
};

/**
 * Fetch the current user's organization affiliations.
 */
export function useFetchUserAffiliations(): UseFetchUserAffiliationsResult {
  const { data, isLoading, error, refetch } = useQuery<
    UserOrganizationAffiliation[]
  >({
    queryKey: ["userAffiliations"],
    queryFn: async () => {
      return apiRequest("/profile/affiliations/", "GET") as Promise<
        UserOrganizationAffiliation[]
      >;
    },
  });

  return {
    affiliations: data ?? [],
    isLoading,
    error: error as Error | null,
    refetch,
  };
}
